import React from 'react'

import { Image as ImageType } from '@application/Types/ComponentTypes'

import { Grid, Image, Wrapper } from './ImageGrid.styled'

export const ImageGrid = ({
    images,
    imageAnimation,
}: {
    images: ImageType[]
    imageAnimation?: boolean
}): JSX.Element => {
    return (
        <Grid>
            {images.map((image) => (
                <Wrapper key={image.alternativeText}>
                    <Image image={image} imageAnimation={imageAnimation} />
                </Wrapper>
            ))}
        </Grid>
    )
}
